import * as types from "../actions/types";



const initialState = {
  list: null,
  loading: false
};


export default function tv_program_type(state = initialState, action) {
  switch (action.type) {
    case types.SET_TV_PROGRAM_TYPE_LIST:
      return {
        ...state,
        list: action.payload
      };
    case types.SET_TV_PROGRAM_TYPE_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
}